import { dataTrimRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrimRight = /*#__PURE__*/createIcon(dataTrimRight)
export default IconTrimRight
